







import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import AuthenticationForm from "@/components/AuthenticationForm.vue";
import { Mutation } from "vuex-class";
import AppLogo from "@/components/ui/AppLogo.vue";
import { RouterPathName } from "@/enums/router-path-name.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Authentication page component
 */
@Component({
  components: { AppLogo, AuthenticationForm }
})
export default class AuthenticationPage extends Vue {
  @Mutation("app/setTitlePrefix") private setTitlePrefix!: (
    newPrefix: string
  ) => void;

  /** Vuex store subscription */
  private storeSub!: () => void;

  created(): void {
    this.storeSub = this.$store.subscribe(mutation => {
      if (mutation.type === "auth/authSuccess") {
        // If user was authenticated successfully then redirect to main app page
        this.$router.push({
          name: RouterPathName.AppMain
        });
      }
    });
    this.setTitlePrefix("Logowanie");
  }

  beforeDestroy(): void {
    // Unsubscribe Vuex store.
    // https://vuex.vuejs.org/api/#subscribe
    this.storeSub();
  }
}
